import React from 'react';
import PropTypes from 'prop-types';
import cookie from 'js-cookie';
import { Form, Upload, Button, Input, Icon, Switch, message } from 'antd';

function UpdateForm({
  form,
  item: { name, plugin_file = '', id, status },
  query,
  closeModal,
}) {
  const uploadApi = id
    ? `${window.G.backendApi}/system/plugin/${id}/`
    : `${window.G.backendApi}/system/plugin/`;
  const formItemLayout = {
    labelCol: {
      sm: { span: 6 },
    },
    wrapperCol: {
      sm: { span: 16 },
    },
  };
  console.info(
    form.getFieldValue('status'),
    typeof form.getFieldValue('status'),
  );
  const props = {
    name: 'plugin_file',
    multiple: false,
    action: uploadApi,
    method: id ? 'PATCH' : 'POST',
    headers: {
      Authorization: `jwt ${cookie.get('AUTH')}`,
    },
    data: {
      name: form.getFieldValue('name'),
      status: form.getFieldValue('status') ? 'on' : 'off',
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(id ? '插件更新成功' : '插件上传成功');
        query();
        closeModal();
      } else if (status === 'error') {
        message.error('上传失败');
      }
    },
  };

  const FormItem = Form.Item;

  const normFile = e => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const { getFieldDecorator, getFieldValue } = form;

  return (
    <Form>
      <FormItem label="插件名称" {...formItemLayout}>
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入插件名称' }],
          initialValue: name,
        })(<Input />)}
      </FormItem>
      <FormItem label="是否启用" {...formItemLayout}>
        {getFieldDecorator('status', {
          initialValue: status ? status === 'on' : true,
        })(<Switch defaultChecked={status ? status === 'on' : true} />)}
      </FormItem>
      <FormItem label="上传文件" {...formItemLayout}>
        {getFieldDecorator('file', {
          rules: [{ required: true, message: '请上传插件' }],
          valuePropName: 'fileList',
          getValueFromEvent: normFile,
        })(
          <Upload {...props} disabled={!getFieldValue('name')}>
            <Button>
              <Icon type="upload" /> 点击上传文件
            </Button>
          </Upload>,
        )}
      </FormItem>
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default Form.create()(UpdateForm);
